/** @format */

import React, { useState, useEffect } from "react";
import SubwayFileUpload from "../../core/file-uploader";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { IconButton } from "@mui/material";
 
const IMAGE_TYPES = ["image/png", "image/jpeg"];

const DocumentPreview = ({
  docs,
  setDocs,
  documentSavingKey,
  documentType,
  clearFiles,
  setClearFiles,
}) => {
  const [files, setFiles] = useState([]);

  useEffect(() => {
    if (clearFiles && setClearFiles) {
      setFiles([]);
      setClearFiles(null);
    }
  }, [clearFiles]);
  const onSucces = (response) => {
    const savedDocument = {};
    const documenturl = response.url.split("?")[0];
    savedDocument[documentSavingKey] = documenturl;
    savedDocument["type"] = documentType;
    savedDocument["originalName"] = response.originalname;

    const newfiles = [...files, { ...response, location: documenturl }];
    setFiles(newfiles);
    setDocs([...docs, savedDocument]);
  };

  const deleteDoc = (delindex) => {
    const { location } = files[delindex];
    const filteredDocs = docs.filter((item) => {
      return item[documentSavingKey] !== location;
    });
    const filteredFiles = files.filter((_, index) => {
      return index !== delindex;
    });
    setFiles(filteredFiles);
    setDocs(filteredDocs);
  };

  return (
    <div className="doc-preview">
      <div className="doc-list">
        {files.map((doc, index) => {
          return (
            <div key={doc.location} className="doc-conatiner">
              <div>
                {IMAGE_TYPES.includes(doc.mimetype) ? (
                  <img className="prev-img" src={doc.location} width="120" />
                ) : (
                  <FilePresentIcon />
                )}
              </div>
              <div className="file-name" title={doc.originalname}>
                {doc.originalname}
              </div>
              <IconButton className="close">
                <HighlightOffIcon onClick={() => deleteDoc(index)} />
              </IconButton>
            </div>
          );
        })}
        {files.length === 0 && <div>No documents attached</div>}
      </div>
      <SubwayFileUpload
        title="Upload document"
        callBack={onSucces}
        acceptType=".pdf,.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      />
    </div>
  );
};

export default DocumentPreview;
